import { PageTitle } from "@/components/PageTitle";
import { Button } from "@industriousoffice/react-components";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export function Success() {
  const { t } = useTranslation("securityDeposit");

  return (
    <div className="h-full flex flex-col">
      <PageTitle>{t("Thank you")}</PageTitle>
      <p>{t("Your form submission has been received.")}</p>
      <p>
        {t(
          "Security deposits will be returned within 45 days of your move out and receipt of your banking information."
        )}
      </p>
      <div className="mt-auto">
        <Link to="/">
          <Button>{t("Go To Billing Dashboard")}</Button>
        </Link>
      </div>
    </div>
  );
}
